// Pull the filename the BE set in Content-Disposition; fall back to a sensible default.
// Handles: filename="x.xlsx", filename=x.xlsx, filename*=UTF-8''x.xlsx
export function resolveContentDispositionFilename(disposition: string | undefined, fallback: string): string {
  if (!disposition) return fallback;
  const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);
  if (!match?.[1]) return fallback;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
}
